import React from 'react';
import PropTypes from 'prop-types';
import styles from './Headline.module.scss';

const Headline = (props) => {
    const HeadlineTag = props.variant === 'subtitle' ? 'div' : props.variant;

    return <HeadlineTag className={styles[props.variant]} style={{ color: props.color }}>{props.children}</HeadlineTag>

}

Headline.propTypes = {
    variant: PropTypes.string.isRequired,
    color: PropTypes.string,
};

export default Headline;
